var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperativesHighContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 348,
    viewBox: "0 0 627 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.000549316 223.37C-0.00695801 232.824 1.25641 242.233 3.75488 251.331C6.16962 260.102 9.72205 268.498 14.3163 276.293C14.3163 304.536 32.8523 328.945 59.7574 340.558C71.0001 345.362 83.0602 347.814 95.2344 347.773H507.975C530.035 347.773 550.478 341.651 567.244 331.222C572.042 328.251 576.593 324.878 580.852 321.137C599.487 304.665 611.04 281.902 611.04 256.76C621.499 240.196 627.044 220.859 627 201.109C627 159.754 603.219 124.194 569.151 108.494C564.627 106.41 559.952 104.691 555.169 103.353C553.478 102.879 551.768 102.454 550.039 102.079C545.432 101.069 540.759 100.41 536.058 100.106C534.359 99.9966 532.651 99.9346 530.933 99.9195H529.991C528.094 99.9195 526.215 99.9872 524.346 100.1L523.732 99.0289C522.979 97.736 522.208 96.4564 521.419 95.1899C519.994 92.8824 518.499 90.6087 516.936 88.3688C515.299 86.0049 513.59 83.6786 511.811 81.3898L511.356 80.8261C510.348 79.5333 509.317 78.2555 508.265 76.9928C504.977 73.0504 501.505 69.2265 497.852 65.5209C458.33 25.6767 396.414 0.0270996 326.808 0.0270996C272.647 0.0270996 223.139 15.5578 185.218 41.2186C170.852 32.8566 154.623 28.469 138.116 28.484C84.5469 28.484 41.1063 73.7908 41.1063 129.679C41.1143 133.215 41.2972 136.748 41.6544 140.265C28.7415 149.667 18.2164 162.126 10.9669 176.589C3.71741 191.053 -0.0438232 207.098 0.000549316 223.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.84 65.4939V76.9657H508.254C504.991 73.0272 501.52 69.2032 497.84 65.4939Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 62.585H492.71V76.9657H478.729V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 62.585H473.604V76.9657H459.623V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.511 62.585H454.493V76.9657H440.511V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 62.585H435.387V76.9657H421.406V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 62.585H416.276V76.9657H402.294V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.182 62.585H397.164V76.9657H383.182V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.077 62.585H378.058V76.9657H364.077V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 62.585H358.947V76.9657H344.965V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 62.585H339.841V76.9657H325.859V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 62.585H320.729V76.9657H306.747V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.636 62.585H301.618V76.9657H287.636V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 62.585H282.512V76.9657H268.53V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 62.585H263.401V76.9657H249.419V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.307 62.585H244.289V76.9657H230.307V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 62.585H225.183V76.9657H211.202V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 62.585H206.071V76.9657H192.09V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.984 62.585H186.966V76.9657H172.984V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.873 62.585H167.854V76.9657H153.873V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 62.585H148.743V76.9657H134.761V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 62.585H129.637V76.9657H115.655V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 62.585H110.525V76.9657H96.5439V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 62.585H91.4197V76.9657H77.4382V62.585Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.946 88.3586V95.1798H521.429C520.004 92.8572 518.51 90.5835 516.946 88.3586Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.84 80.7991H511.822V95.1797H497.84V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 80.7991H492.71V95.1797H478.729V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 80.7991H473.604V95.1797H459.623V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 80.7991H454.493V95.1797H440.511V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 80.7991H435.387V95.1797H421.406V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M402.294 80.7991H416.276V95.1797H402.294V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.182 80.7991H397.164V95.1797H383.182V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M364.077 80.7991H378.058V95.1797H364.077V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 80.7991H358.947V95.1797H344.965V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.859 80.7991H339.841V95.1797H325.859V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 80.7991H320.729V95.1797H306.747V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.636 80.7991H301.618V95.1797H287.636V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 80.7991H282.512V95.1797H268.53V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 80.7991H263.401V95.1797H249.419V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.307 80.7991H244.289V95.1797H230.307V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.202 80.7991H225.183V95.1797H211.202V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 80.7991H206.071V95.1797H192.09V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 80.7991H186.966V95.1797H172.984V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.873 80.7991H167.854V95.1797H153.873V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 80.7991H148.743V95.1797H134.761V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.655 80.7991H129.637V95.1797H115.655V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 80.7991H110.525V95.1797H96.5439V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 80.7991H91.4197V95.1797H77.4382V80.7991Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 103.348V113.399H569.151V108.489C564.627 106.406 559.952 104.687 555.169 103.348Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 100.101V113.399H550.039V102.074L536.058 100.101Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.952 99.0188H530.933V113.399H516.952V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M497.84 99.0188H511.822V113.399H497.84V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 99.0188H492.71V113.399H478.729V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 99.0188H473.604V113.399H459.623V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 99.0188H454.493V113.399H440.511V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 99.0188H435.387V113.399H421.406V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M402.294 99.0188H416.276V113.399H402.294V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.182 99.0188H397.164V113.399H383.182V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 99.0188H378.058V113.399H364.077V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 99.0188H358.947V113.399H344.965V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.859 99.0188H339.841V113.399H325.859V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 99.0188H320.729V113.399H306.747V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.636 99.0188H301.618V113.399H287.636V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 99.0188H282.512V113.399H268.53V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 99.0188H263.401V113.399H249.419V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.307 99.0188H244.289V113.399H230.307V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 99.0188H225.183V113.399H211.202V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M192.09 99.0188H206.071V113.399H192.09V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M172.984 99.0188H186.966V113.399H172.984V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.873 99.0188H167.854V113.399H153.873V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 99.0188H148.743V113.399H134.761V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.655 99.0188H129.637V113.399H115.655V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 99.0188H110.525V113.399H96.5439V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 99.0188H91.4197V113.399H77.4382V99.0188Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 117.233H569.151V131.613H555.169V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 117.233H550.039V131.613H536.058V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M516.952 117.233H530.933V131.613H516.952V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.84 117.233H511.822V131.613H497.84V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 117.233H492.71V131.613H478.729V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 117.233H473.604V131.613H459.623V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 117.233H454.493V131.613H440.511V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 117.233H435.387V131.613H421.406V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 117.233H416.276V131.613H402.294V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.182 117.233H397.164V131.613H383.182V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M364.077 117.233H378.058V131.613H364.077V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.965 117.233H358.947V131.613H344.965V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 117.233H339.841V131.613H325.859V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M306.747 117.233H320.729V131.613H306.747V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.636 117.233H301.618V131.613H287.636V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 117.233H282.512V131.613H268.53V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.419 117.233H263.401V131.613H249.419V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.307 117.233H244.289V131.613H230.307V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 117.233H225.183V131.613H211.202V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 117.233H206.071V131.613H192.09V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 117.233H186.966V131.613H172.984V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M153.873 117.233H167.854V131.613H153.873V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M134.761 117.233H148.743V131.613H134.761V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.655 117.233H129.637V131.613H115.655V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 117.233H110.525V131.613H96.5439V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 117.233H91.4197V131.613H77.4382V117.233Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 135.452H569.151V149.833H555.169V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 135.452H550.039V149.833H536.058V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M516.952 135.452H530.933V149.833H516.952V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.84 135.452H511.822V149.833H497.84V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 135.452H492.71V149.833H478.729V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 135.452H473.604V149.833H459.623V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 135.452H454.493V149.833H440.511V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 135.452H435.387V149.833H421.406V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 135.452H416.276V149.833H402.294V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.182 135.452H397.164V149.833H383.182V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 135.452H378.058V149.833H364.077V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 135.452H358.947V149.833H344.965V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.859 135.452H339.841V149.833H325.859V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 135.452H320.729V149.833H306.747V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.636 135.452H301.618V149.833H287.636V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 135.452H282.512V149.833H268.53V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.419 135.452H263.401V149.833H249.419V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.307 135.452H244.289V149.833H230.307V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 135.452H225.183V149.833H211.202V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 135.452H206.071V149.833H192.09V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 135.452H186.966V149.833H172.984V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 135.452H167.854V149.833H153.873V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M134.761 135.452H148.743V149.833H134.761V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 135.452H129.637V149.833H115.655V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 135.452H110.525V149.833H96.5439V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 135.452H91.4197V149.833H77.4382V135.452Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 153.666H569.151V168.047H555.169V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 153.666H550.039V168.047H536.058V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M516.952 153.666H530.933V168.047H516.952V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M497.84 153.666H511.822V168.047H497.84V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 153.666H492.71V168.047H478.729V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 153.666H473.604V168.047H459.623V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 153.666H454.493V168.047H440.511V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 153.666H435.387V168.047H421.406V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 153.666H416.276V168.047H402.294V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.182 153.666H397.164V168.047H383.182V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 153.666H378.058V168.047H364.077V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 153.666H358.947V168.047H344.965V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.859 153.666H339.841V168.047H325.859V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 153.666H320.729V168.047H306.747V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.636 153.666H301.618V168.047H287.636V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 153.666H282.512V168.047H268.53V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 153.666H263.401V168.047H249.419V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.307 153.666H244.289V168.047H230.307V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 153.666H225.183V168.047H211.202V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 153.666H206.071V168.047H192.09V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 153.666H186.966V168.047H172.984V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 153.666H167.854V168.047H153.873V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 153.666H148.743V168.047H134.761V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 153.666H129.637V168.047H115.655V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.5439 153.666H110.525V168.047H96.5439V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 153.666H91.4197V168.047H77.4382V153.666Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M555.169 171.886H569.151V186.267H555.169V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M536.058 171.886H550.039V186.267H536.058V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M516.952 171.886H530.933V186.267H516.952V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M497.84 171.886H511.822V186.267H497.84V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M478.729 171.886H492.71V186.267H478.729V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 171.886H473.604V186.267H459.623V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.511 171.886H454.493V186.267H440.511V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.406 171.886H435.387V186.267H421.406V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 171.886H416.276V186.267H402.294V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.182 171.886H397.164V186.267H383.182V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.077 171.886H378.058V186.267H364.077V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.965 171.886H358.947V186.267H344.965V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 171.886H339.841V186.267H325.859V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.747 171.886H320.729V186.267H306.747V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.636 171.886H301.618V186.267H287.636V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53 171.886H282.512V186.267H268.53V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 171.886H263.401V186.267H249.419V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.307 171.886H244.289V186.267H230.307V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.202 171.886H225.183V186.267H211.202V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 171.886H206.071V186.267H192.09V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 171.886H186.966V186.267H172.984V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 171.886H167.854V186.267H153.873V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 171.886H148.743V186.267H134.761V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 171.886H129.637V186.267H115.655V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 171.886H110.525V186.267H96.5439V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4382 171.886H91.4197V186.267H77.4382V171.886Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.426 224.792C213.872 224.792 205.315 215.991 205.315 205.135C205.315 194.278 213.872 185.478 224.426 185.478C234.981 185.478 243.538 194.278 243.538 205.135C243.538 215.991 234.981 224.792 224.426 224.792Z",
    fill: "#767D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.419 180.128C223.511 188.689 221.893 197.314 220.563 206.003C220.163 208.585 219.806 211.307 220.716 213.748C221.478 215.783 223.029 217.373 224.246 219.155C225.462 220.936 226.383 223.219 225.643 225.26C224.903 227.3 222.744 228.417 220.683 228.992C214.786 230.626 208.499 229.437 202.63 227.667C199.972 226.963 197.424 225.878 195.061 224.442C192.572 222.819 190.534 220.564 188.659 218.241C180.104 207.57 174.502 194.762 169.23 182.033C172.618 182.35 176.03 181.834 179.186 180.526C182.341 179.218 185.149 177.157 187.377 174.513C189.536 171.903 191.12 168.267 189.903 165.076C193.471 167.089 197.708 167.224 201.55 168.599C203.933 169.535 206.226 170.696 208.401 172.066C211.024 173.626 213.633 175.216 216.227 176.836C219.192 178.673 221.971 180.308 225.419 180.128Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.447 194.886C188.796 201.589 193.153 208.032 199.374 212.023C205.595 216.015 213.969 217.097 220.201 213.151C223.27 211.223 225.594 208.292 228.274 205.822C230.954 203.353 234.303 201.239 237.904 201.561C241.872 201.916 244.98 205.101 247.638 208.151C251.672 212.785 255.568 217.616 258.424 223.101C263.905 233.642 265.204 245.965 264.962 257.916C264.721 269.867 263.039 281.756 263 293.707C262.945 308.41 265.368 322.993 267.818 337.475C245.292 334.623 222.739 340.858 200.163 343.22C185.716 344.747 171.159 344.714 156.635 344.674C154.081 344.674 151.362 344.606 149.236 343.152C147.936 342.177 146.885 340.892 146.172 339.409C144.166 335.604 143.361 331.263 142.802 326.973C141.382 316.138 141.338 305.168 141.3 294.232C141.201 267.737 141.108 241.146 144.38 214.859C145.186 208.393 146.216 201.893 148.628 195.845C151.039 189.796 154.974 184.232 160.477 180.99C164.012 178.905 172.206 175.274 176.371 177.377C181.046 179.722 183.206 190.399 185.447 194.886Z",
    fill: "#767D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.781 269.704C184.63 253.356 188.089 235.909 180.728 221.398C178.919 217.836 185.409 213.388 183.403 209.938C180.955 205.731 179.098 201.19 177.889 196.448C177.473 194.819 177.138 193.094 177.533 191.459C178.262 188.477 181.128 186.701 183.562 184.886C186.247 182.879 187.628 176.762 188.494 173.453C189.36 170.144 181.605 174.13 178.486 172.952C174.157 171.322 168.654 172.348 164.335 174C161.924 174.913 159.304 174.992 156.733 175.06C151.74 175.195 146.731 175.325 141.776 174.693C139.551 174.406 137.32 173.972 135.084 174.102C129.379 174.434 124.419 178.448 121.043 183.194C117.666 187.941 115.518 193.471 112.75 198.612C110.443 202.897 107.691 206.944 105.724 211.403C103.981 215.349 102.879 219.589 101.789 223.805L98.977 234.623C98.4851 236.171 98.2516 237.793 98.2864 239.421C98.4289 241.151 99.1743 242.764 99.9306 244.302C102.791 250.007 106.22 255.389 110.163 260.363C116.077 267.821 123.257 274.546 126.77 283.476C128.14 286.954 128.902 290.652 129.598 294.339C132.404 309.084 134.399 323.981 135.572 338.958C141.976 335.91 148.689 333.601 155.588 332.075C159.027 331.318 162.503 330.753 166.001 330.384C169.065 330.057 173.017 330.677 175.932 329.82C180.81 328.394 181.347 319.91 182.087 315.467C183.271 308.393 183.507 301.194 183.551 294.046C183.606 285.917 183.359 277.805 183.781 269.704Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.903 239.133C288.596 252.662 286.053 266.231 281.038 278.943C281.164 279.067 281.29 279.18 281.416 279.293C281.86 279.682 282.32 280.048 282.802 280.42C283.926 281.232 285.159 281.92 286.091 282.98C286.444 283.385 286.722 283.853 286.913 284.361C287.085 284.757 287.174 285.187 287.174 285.621C287.174 286.055 287.085 286.484 286.913 286.881C289.527 288.07 292.564 287.704 295.496 287.591C298.023 287.495 300.472 287.591 302.5 289.017C305.317 291.013 306.167 294.846 306.622 298.33C306.79 299.6 306.934 300.872 307.055 302.146C307.172 303.33 307.267 304.518 307.34 305.709C307.588 309.65 307.623 313.602 307.444 317.547C307.415 318.269 307.376 318.991 307.329 319.712C316.284 319.492 324.445 314.689 332.168 310.022C333.932 308.956 335.752 307.834 336.898 306.076C337.953 304.348 338.4 302.3 338.164 300.275C338.164 299.987 338.114 299.711 338.076 299.418C337.831 297.745 337.41 296.104 336.821 294.525C334.405 287.796 330.843 281.564 326.303 276.119C324.341 273.763 322.132 271.457 321.217 268.498C320.817 267.207 320.669 265.837 320.263 264.551C318.444 258.982 311.878 256.349 309.631 250.943C309.083 249.652 308.831 248.237 308.151 246.997C307.539 245.966 306.75 245.059 305.822 244.319C305.422 243.975 305.005 243.643 304.594 243.31C300.743 240.206 297.032 236.927 293.463 233.473C292.798 232.831 292.14 232.18 291.489 231.523C291.576 234.074 291.38 236.627 290.903 239.133Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.673 199.12C236.462 199.977 237.317 200.783 238.156 201.583L238.38 201.792L239.268 202.637C240.88 204.068 242.275 205.738 243.406 207.593L243.5 207.75C246.295 212.897 245.259 219.234 244.481 225.079C243.515 232.364 243.081 239.713 243.182 247.065C243.324 257.212 244.486 267.291 244.508 277.427C244.508 279.727 244.459 282.021 244.36 284.321C244.201 288.059 243.927 291.791 243.598 295.523C243.242 299.615 242.814 303.702 242.414 307.789C242.096 310.952 241.795 314.109 241.543 317.266C241.417 318.9 241.296 320.53 241.198 322.164C241.083 324.081 240.989 326.003 240.935 327.92C240.896 329.138 240.874 330.35 240.874 331.567C240.874 332.261 240.874 332.948 240.874 333.636C240.874 334.955 240.909 336.271 240.978 337.582C241.051 339.27 241.163 340.961 241.313 342.656C241.483 344.499 241.784 346.512 243.045 347.808C243.121 347.887 243.204 347.961 243.286 348.034L245.062 347.808C257.303 346.301 269.661 346.074 281.947 347.132C281.679 345.226 281.432 343.327 281.191 341.416C281.081 340.514 280.972 339.606 280.867 338.698C280.747 337.661 280.632 336.624 280.522 335.587C280.396 334.459 280.281 333.332 280.171 332.204C279.886 329.299 279.636 326.392 279.42 323.484C279.103 319.241 278.861 314.99 278.697 310.732C278.617 308.699 278.554 306.664 278.511 304.627C278.449 302.101 278.419 299.574 278.423 297.045C278.423 294.587 278.443 292.125 278.483 289.66C278.483 288.848 278.516 288.036 278.582 287.23C278.629 286.504 278.726 285.783 278.872 285.071C279.279 283.43 279.83 281.83 280.517 280.291C280.637 279.998 280.752 279.727 280.867 279.417C280.933 279.265 280.993 279.107 281.054 278.955C277.897 276.063 275.65 272.19 273.49 268.379C269.988 262.24 266.404 255.831 265.817 248.739C265.231 241.647 268.656 233.682 275.244 231.517C277.036 230.953 278.933 230.796 280.78 230.463C282.523 230.147 286.156 229.431 288.173 228.146C289.269 229.304 290.366 230.44 291.462 231.557C291.395 229.854 290.99 228.183 290.272 226.647L289.494 226.686C289.558 226.505 289.587 226.314 289.582 226.122C289.582 225.519 289.176 224.837 288.31 224.082C285.729 221.827 281.668 221.325 280.04 218.275C279.36 217.007 279.245 215.496 278.697 214.166C277.124 210.372 272.608 208.974 269.889 205.941C267.171 202.908 266.491 198.612 264.294 195.23C262.652 192.76 260.375 190.808 257.717 189.593C257.497 189.486 257.273 189.379 257.048 189.283C252.499 187.281 247.095 186.825 242.381 186.836C240.551 186.836 235.805 186.893 233.481 187.845C233.104 187.984 232.759 188.201 232.467 188.482C229.989 191.256 233.842 197.113 235.673 199.12Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.086 226.252C285.852 224.941 281.408 224.508 277.01 224.98C272.612 225.451 268.349 226.817 264.469 228.997C260.523 231.252 256.982 234.398 254.812 238.456C251.551 244.545 251.694 251.884 251.924 258.835C252.039 262.313 252.187 265.916 253.678 269.039C255.404 272.652 258.66 275.133 261.981 277.162C264.062 278.527 266.341 279.542 268.733 280.167C272.416 280.99 276.242 280.291 279.952 279.603C283.986 278.836 288.316 277.912 291.117 274.822C292.761 273.03 293.66 270.702 294.548 268.424C295.823 265.136 297.102 261.851 298.384 258.57C300.604 252.871 301.355 248.13 298.423 242.577C297.091 240.046 295.463 237.679 294.148 235.13C293.49 233.834 291.133 226.584 290.086 226.252Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7405 323.703V340.559C70.9832 345.363 83.0434 347.816 95.2175 347.774H243.028C243.105 347.853 243.187 347.927 243.27 348L245.045 347.774H507.974C530.034 347.774 550.478 341.652 567.243 331.223V305.489L440.791 290.477H440.692L367.053 296.893L347.996 298.584L338.098 299.446L317.611 301.233L307.071 302.152L291.725 303.494L289.566 303.68L278.505 304.644L263.499 305.912L242.398 307.75L207.223 310.822L182.477 312.981L141.842 316.527L134.115 317.198L133.281 317.271L132.558 317.333L122.353 318.224L111.15 319.205L109.851 319.318L59.7405 323.703Z",
    fill: "#00D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27 323.083L366.74 295.263L372.884 327.221L300.242 336.167L277.875 339.048L216.348 326.584L208.27 323.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 337.447L210.906 322.097C210.509 322.018 210.099 322.032 209.708 322.135C209.316 322.239 208.952 322.43 208.64 322.696C208.329 322.962 208.079 323.295 207.908 323.672C207.737 324.049 207.649 324.46 207.65 324.876C207.648 325.536 207.872 326.175 208.281 326.683C208.691 327.191 209.261 327.535 209.892 327.655L287.428 342.588L290.3 337.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.859 289.175C253.387 288.938 250.882 288.538 248.657 287.411C245.916 286.007 243.784 283.589 241.247 281.807C235.667 277.861 228.203 277.331 221.806 279.597C215.41 281.864 210.072 286.717 206.334 292.512C203.851 296.374 201.988 301.301 203.742 305.563C204.344 306.865 205.102 308.085 206 309.193L210.571 315.338C211.439 316.629 212.484 317.786 213.673 318.771C215.383 320.05 217.51 320.575 219.603 320.89C225.166 321.725 230.828 321.251 236.435 321.634C246.064 322.294 255.469 325.485 265.121 325.378C270.668 325.316 276.143 324.166 281.563 323.016L305.553 317.942C309.729 317.063 314.448 315.777 316.416 311.882C317.298 310.129 317.462 308.099 317.566 306.126C317.851 300.692 317.566 294.649 313.905 290.731C310.463 287.055 305.021 285.894 300.91 283.177C295.879 279.845 294.218 280.922 288.913 283.425C278.563 288.246 267.175 290.227 255.859 289.175Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M255.859 289.175C253.387 288.938 250.882 288.538 248.657 287.411C245.916 286.007 243.784 283.589 241.247 281.807C235.667 277.861 228.203 277.331 221.806 279.597C215.41 281.864 210.072 286.717 206.334 292.512C203.851 296.374 201.988 301.301 203.742 305.563C204.344 306.865 205.102 308.085 206 309.193L210.571 315.338C211.439 316.629 212.484 317.786 213.673 318.771C215.383 320.05 217.51 320.575 219.603 320.89C225.166 321.725 230.828 321.251 236.435 321.634C246.064 322.294 255.469 325.485 265.121 325.378C270.668 325.316 276.143 324.166 281.563 323.016L305.553 317.942C309.729 317.063 314.448 315.777 316.416 311.882C317.298 310.129 317.462 308.099 317.566 306.126C317.851 300.692 317.566 294.649 313.905 290.731C310.463 287.055 305.021 285.894 300.91 283.177C295.879 279.845 294.218 280.922 288.913 283.425C278.563 288.246 267.175 290.227 255.859 289.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.523 281.446C166.254 284.124 173.023 286.813 180.071 288.408C191.887 291.086 204.252 290.663 215.975 293.724C222.169 295.348 228.323 297.964 234.687 297.434C237.531 297.197 240.277 296.306 243.045 295.63C258.594 291.684 276.269 292.963 288.897 303.11C293.216 306.577 296.751 310.901 299.957 315.512C300.643 316.508 301.107 317.648 301.315 318.85C301.523 320.051 301.471 321.286 301.161 322.464C300.852 323.642 300.293 324.736 299.525 325.667C298.757 326.597 297.798 327.341 296.718 327.847C291.807 330.17 286.547 331.613 281.164 332.114C273.967 332.768 266.738 331.72 259.58 330.671C248.959 329.121 238.331 327.565 227.737 325.823C223.933 325.197 220.13 324.549 216.304 324.053C188.774 320.473 160.746 324.825 133.144 321.837C130.355 321.533 127.516 321.138 124.978 319.915C118.555 316.815 115.376 308.641 116.702 301.459C118.028 294.277 123.148 288.307 129.308 284.643C134.471 281.559 140.039 280.313 145.789 279.005C151.127 277.726 154.382 279.417 159.523 281.446Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.479 238.513C97.4426 242.606 96.7959 248.096 97.1248 253.221C97.4536 258.345 98.6374 263.413 98.8128 268.56C99.054 275.617 97.3988 282.653 97.6783 289.688C97.8756 294.609 99.0101 299.435 100.353 304.159C101.937 309.734 104.228 315.727 109.232 318.404C115.874 321.961 129.807 319.96 136.795 322.745C136.159 318.669 130.064 312.767 129.428 308.691C128.99 305.873 128.546 302.975 129.017 300.151C129.62 296.549 131.676 293.352 134.114 290.692C137.995 286.458 143.059 283.273 148.622 282.236C154.185 281.198 167.805 282.05 172.255 285.663C172.803 281.931 162.609 278.335 159.025 277.529C157.238 277.117 155.188 277.348 153.758 276.181C151.017 273.971 153.007 269.569 152.875 266.034C152.771 263.215 151.171 260.634 150.847 257.815C150.299 253.305 153.16 248.711 152.037 244.285C151.62 242.651 150.694 241.213 150.053 239.657C148.101 234.894 148.956 229.459 149.998 224.397C150.644 221.218 151.275 217.632 149.554 214.921C147.959 212.39 143.432 221.404 140.532 220.987C130.958 219.605 122.292 212.305 114.559 218.281C110.618 221.325 110.103 224.482 108.53 228.828C107.001 232.966 103.039 235.085 100.479 238.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8346 238.513C95.7983 242.605 95.1516 248.096 95.4804 253.22C95.8093 258.345 96.9931 263.413 97.1685 268.559C97.4096 275.617 95.7544 282.653 96.034 289.688C96.2313 294.609 97.3658 299.435 98.7086 304.159C100.293 309.734 102.583 315.727 107.587 318.404C114.23 321.961 128.162 319.96 135.15 322.745C134.514 318.669 128.42 312.767 127.784 308.691C127.346 305.873 126.902 302.975 127.373 300.151C127.976 296.549 130.031 293.352 132.47 290.691C136.351 286.458 141.415 283.273 146.978 282.236C152.541 281.198 166.16 282.049 170.611 285.663C171.159 281.931 160.965 278.335 157.38 277.528C155.594 277.117 153.544 277.348 152.113 276.181C149.373 273.971 151.362 269.569 151.231 266.034C151.127 263.215 149.526 260.633 149.203 257.815C148.655 253.305 151.516 248.711 150.392 244.285C149.976 242.651 149.049 241.213 148.408 239.657C146.457 234.894 147.312 229.459 148.353 224.397C149 221.218 149.63 217.632 147.909 214.921C146.315 212.39 143.196 211.431 140.297 211.009C130.589 209.658 120.753 212.268 112.893 218.281C108.952 221.325 108.437 224.482 106.864 228.828C105.357 232.966 101.394 235.085 98.8346 238.513Z",
    fill: "#FCB827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.481 211.804L431.682 325.079C431.316 326.467 430.548 327.707 429.48 328.635C428.412 329.562 427.094 330.133 425.702 330.271L291.577 343.524C290.484 343.632 289.381 343.47 288.362 343.05C287.342 342.63 286.436 341.965 285.718 341.11C284.999 340.256 284.491 339.236 284.234 338.138C283.978 337.04 283.981 335.894 284.244 334.797L316.876 198.161C317.264 196.537 318.2 195.107 319.517 194.126C320.833 193.144 322.445 192.675 324.067 192.8L455.381 202.902C456.389 202.983 457.367 203.291 458.246 203.806C459.125 204.32 459.883 205.027 460.466 205.877C461.049 206.728 461.442 207.699 461.617 208.724C461.792 209.748 461.746 210.8 461.481 211.804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.437 333.725L298.318 332.316L298.208 330.882L298.113 329.771C298.088 329.473 298.28 329.18 298.7 328.892C299.122 328.615 299.541 328.459 299.971 328.423C300.234 328.401 300.407 328.458 300.504 328.606C300.601 328.754 300.656 328.978 300.681 329.277C300.681 329.277 300.765 330.124 300.797 330.494C300.804 330.577 300.882 330.643 300.965 330.636L301.132 330.622C301.574 330.584 301.878 330.618 302.054 330.712C302.219 330.818 302.321 331.026 302.347 331.324C302.358 331.456 302.343 331.565 302.302 331.653C302.262 331.74 302.196 331.818 302.093 331.875C301.989 331.932 301.861 331.979 301.707 332.004C301.554 332.041 301.375 332.068 301.149 332.088L301.041 332.097C300.981 332.102 300.938 332.154 300.943 332.213L301.045 333.419C301.056 333.551 301.076 333.645 301.095 333.728C301.115 333.81 301.133 333.881 301.16 333.927C301.188 333.972 301.227 334.005 301.276 334.013C301.313 334.022 301.374 334.029 301.433 334.024C301.529 334.016 301.609 333.973 301.663 333.896C301.718 333.831 301.77 333.743 301.799 333.656C301.828 333.569 301.869 333.494 301.923 333.417C301.978 333.352 302.034 333.311 302.118 333.304C302.297 333.289 302.444 333.324 302.559 333.399C302.662 333.474 302.718 333.578 302.73 333.709C302.748 333.924 302.731 334.154 302.669 334.412C302.607 334.67 302.496 334.92 302.36 335.16C302.224 335.4 302.013 335.61 301.752 335.789C301.478 335.968 301.162 336.067 300.816 336.097C300.027 336.164 299.449 336.008 299.093 335.642C298.737 335.275 298.514 334.632 298.437 333.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.579 335.725C305.611 335.807 304.79 335.624 304.115 335.177C303.439 334.729 303.059 334.076 302.985 333.204C302.905 332.261 303.152 331.494 303.739 330.891C304.314 330.301 305.091 329.958 306.082 329.874C307.013 329.795 307.708 329.904 308.177 330.189C308.635 330.487 308.889 330.922 308.938 331.496C308.947 331.603 308.944 331.712 308.929 331.821C308.902 331.932 308.875 332.03 308.823 332.131C308.773 332.243 308.696 332.334 308.608 332.426C308.507 332.518 308.407 332.611 308.281 332.682C308.155 332.765 308.016 332.825 307.84 332.876C307.664 332.927 307.487 332.966 307.284 332.983L305.601 333.138C305.706 333.382 305.867 333.573 306.082 333.699C306.298 333.837 306.567 333.886 306.889 333.859C307.235 333.829 307.578 333.752 307.929 333.638C308.081 333.589 308.23 333.504 308.414 333.404C308.586 333.305 308.701 333.248 308.785 333.24C308.916 333.229 309.027 333.256 309.118 333.332C309.196 333.41 309.24 333.502 309.25 333.622C309.263 333.765 309.217 333.937 309.103 334.152C308.989 334.366 308.839 334.583 308.629 334.805C308.408 335.028 308.124 335.233 307.766 335.408C307.408 335.582 307.008 335.689 306.579 335.725ZM305.477 332.379C306.025 332.32 306.323 332.295 306.371 332.291C306.491 332.281 306.568 332.202 306.616 332.054C306.642 331.943 306.654 331.798 306.639 331.619C306.596 331.117 306.42 330.88 306.121 330.905C306.014 330.914 305.911 330.983 305.814 331.111C305.717 331.24 305.635 331.415 305.57 331.637C305.506 331.871 305.478 332.114 305.477 332.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.873 335.228C311.24 335.282 310.704 335.063 310.243 334.585C309.782 334.119 309.519 333.431 309.443 332.536C309.366 331.628 309.507 330.883 309.88 330.31C310.24 329.738 310.743 329.431 311.376 329.377C312.021 329.322 312.637 329.498 313.225 329.905C313.406 329.493 313.735 329.261 314.213 329.22C314.643 329.184 314.985 329.251 315.239 329.41C315.494 329.58 315.643 329.916 315.686 330.418L315.95 333.523C315.99 334 315.923 334.343 315.735 334.539C315.548 334.747 315.21 334.872 314.709 334.915C314.183 334.96 313.825 334.846 313.632 334.561C313.148 334.951 312.565 335.169 311.873 335.228ZM313.155 331.066C313.004 330.85 312.815 330.746 312.6 330.764C312.397 330.782 312.243 330.951 312.137 331.261C312.031 331.57 312.001 331.922 312.034 332.316C312.066 332.686 312.153 333.003 312.297 333.28C312.44 333.556 312.62 333.685 312.835 333.667C313.062 333.648 313.232 333.525 313.345 333.299L313.155 331.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.316 331.008C323.278 330.566 323.08 330.355 322.722 330.385C322.566 330.398 322.455 330.504 322.387 330.69C322.318 330.876 322.303 331.118 322.326 331.393C322.362 331.811 322.392 332.169 322.403 332.445C322.415 332.72 322.4 332.974 322.384 333.204C322.367 333.434 322.334 333.605 322.285 333.742C322.237 333.878 322.173 333.98 322.085 334.071C321.996 334.163 321.894 334.232 321.776 334.266C321.66 334.312 321.506 334.337 321.327 334.352C321.052 334.376 320.822 334.359 320.648 334.29C320.462 334.221 320.333 334.124 320.249 333.987C320.165 333.85 320.114 333.674 320.096 333.459L319.913 331.297C319.875 330.855 319.677 330.644 319.318 330.674C319.175 330.686 319.063 330.78 318.992 330.942C318.911 331.118 318.882 331.337 318.904 331.599L319.045 333.259C319.085 333.737 319.018 334.079 318.831 334.276C318.644 334.484 318.306 334.609 317.804 334.652C317.338 334.691 317.007 334.611 316.82 334.398C316.623 334.199 316.509 333.847 316.466 333.346L316.217 330.408C316.182 330.002 316.263 329.671 316.468 329.401C316.662 329.132 316.938 328.988 317.308 328.957C317.965 328.901 318.389 329.081 318.604 329.484C318.883 329.232 319.169 329.051 319.46 328.942C319.739 328.834 320.07 328.758 320.464 328.725C321.049 328.675 321.5 328.889 321.806 329.38C321.839 329.342 321.885 329.314 321.918 329.275C322.489 328.781 323.222 328.49 324.118 328.414C324.679 328.367 325.103 328.547 325.391 328.956C325.678 329.364 325.858 330.071 325.944 331.086C325.98 331.504 326.01 331.862 326.022 332.137C326.021 332.414 326.018 332.667 326.002 332.897C325.985 333.127 325.94 333.299 325.903 333.434C325.855 333.571 325.779 333.673 325.679 333.766C325.579 333.859 325.464 333.929 325.335 333.964C325.207 334.011 325.04 334.037 324.837 334.054C324.539 334.079 324.285 334.065 324.099 333.997C323.901 333.929 323.76 333.833 323.664 333.697C323.569 333.561 323.518 333.384 323.499 333.17L323.316 331.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.511 330.011C332.627 331.372 332.672 332.33 332.634 332.875C332.616 333.369 332.544 333.796 332.443 334.166C332.341 334.523 332.178 334.862 331.95 335.158C331.723 335.454 331.43 335.683 331.059 335.847C330.688 336.011 330.24 336.121 329.715 336.166C329.297 336.201 328.898 336.175 328.529 336.086C328.148 335.986 327.848 335.855 327.631 335.705C327.4 335.532 327.218 335.379 327.084 335.21C326.949 335.041 326.877 334.903 326.866 334.772C326.855 334.64 326.894 334.529 326.968 334.414C327.042 334.288 327.145 334.231 327.288 334.219C327.396 334.21 327.518 334.235 327.666 334.283C327.803 334.331 327.94 334.392 328.079 334.464C328.217 334.537 328.367 334.596 328.551 334.641C328.735 334.685 328.905 334.707 329.072 334.693C329.502 334.656 329.804 334.522 329.964 334.292C330.125 334.062 330.183 333.744 330.149 333.35C330.023 333.421 329.896 333.48 329.767 333.527C329.639 333.574 329.523 333.62 329.405 333.654C329.288 333.688 329.181 333.709 329.075 333.73C328.968 333.751 328.861 333.76 328.753 333.77C328.288 333.809 327.871 333.712 327.514 333.478C327.157 333.244 326.891 332.942 326.714 332.56C326.527 332.191 326.419 331.779 326.382 331.337C326.344 330.895 326.324 330.512 326.309 330.201C326.295 329.889 326.296 329.612 326.31 329.359C326.326 329.117 326.357 328.922 326.405 328.773C326.44 328.626 326.502 328.5 326.589 328.397C326.678 328.305 326.78 328.236 326.896 328.19C327.013 328.144 327.155 328.12 327.322 328.106C327.824 328.063 328.189 328.117 328.406 328.267C328.625 328.428 328.742 328.683 328.774 329.053L328.949 330.975L328.972 331.249C328.977 331.309 328.996 331.392 329.016 331.474C329.035 331.557 329.053 331.627 329.08 331.661C329.095 331.696 329.134 331.741 329.173 331.773C329.213 331.818 329.264 331.85 329.325 331.857C329.385 331.864 329.458 331.87 329.542 331.862C329.78 331.842 329.93 331.757 329.978 331.621C330.027 331.485 330.03 331.244 330.001 330.897L329.849 328.962C329.827 328.711 329.859 328.516 329.929 328.354C330 328.191 330.122 328.073 330.318 327.972C330.514 327.871 330.773 327.813 331.12 327.784C331.323 327.766 331.505 327.787 331.665 327.833C331.814 327.893 331.941 327.966 332.034 328.067C332.126 328.167 332.212 328.328 332.277 328.527C332.331 328.739 332.385 328.951 332.416 329.165C332.446 329.379 332.482 329.664 332.511 330.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.038 332.031C334.189 332.018 334.303 332.041 334.372 332.091C334.433 332.15 334.474 332.259 334.487 332.41L334.52 332.793C334.532 332.944 334.51 333.058 334.459 333.119C334.401 333.188 334.292 333.229 334.14 333.242L333.838 333.268C333.686 333.281 333.572 333.258 333.511 333.199C333.443 333.149 333.401 333.04 333.388 332.889L333.356 332.506C333.343 332.355 333.365 332.241 333.424 332.172C333.475 332.111 333.584 332.07 333.735 332.057L334.038 332.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.821 332.299C337.741 332.412 337.641 332.524 337.526 332.635C337.393 332.761 337.233 332.872 337.048 332.969C336.862 333.064 336.649 333.123 336.407 333.143C336.17 333.163 335.954 333.139 335.755 333.07C335.55 333.002 335.392 332.89 335.264 332.735C335.137 332.58 335.065 332.38 335.044 332.136L335.01 331.73C334.983 331.416 335.071 331.162 335.268 330.969C335.465 330.776 335.749 330.664 336.119 330.632L337.555 330.51L337.539 330.327C337.518 330.136 337.457 330.004 337.366 329.928C337.27 329.854 337.104 329.827 336.862 329.847C336.655 329.865 336.404 329.892 336.099 329.932C335.878 329.96 335.652 329.992 335.417 330.026C335.279 330.047 335.147 329.956 335.121 329.82C335.113 329.787 335.105 329.752 335.097 329.717C335.072 329.601 335.092 329.479 335.158 329.379C335.224 329.278 335.322 329.208 335.439 329.183C335.508 329.168 335.581 329.153 335.654 329.139C335.899 329.092 336.143 329.048 336.393 329.008C336.639 328.969 336.86 328.94 337.057 328.924C337.388 328.896 337.668 328.916 337.907 328.984C338.141 329.052 338.327 329.187 338.468 329.386C338.604 329.585 338.687 329.866 338.718 330.227L338.92 332.606C338.925 332.666 338.905 332.726 338.87 332.772C338.829 332.817 338.771 332.846 338.712 332.851C338.623 332.859 338.515 332.868 338.406 332.877C338.175 332.897 337.958 332.749 337.894 332.523L337.83 332.288L337.821 332.299ZM340.287 328.754C340.44 328.741 340.574 328.854 340.587 329.007C340.648 329.729 340.813 331.667 340.874 332.39C340.887 332.542 340.774 332.676 340.621 332.689C340.439 332.704 340.197 332.725 340.01 332.741C339.857 332.754 339.723 332.641 339.71 332.488C339.649 331.766 339.484 329.828 339.423 329.105C339.41 328.953 339.523 328.819 339.675 328.806L340.287 328.754ZM337.507 331.181C337.566 331.176 337.615 331.218 337.619 331.274C337.632 331.416 337.653 331.668 337.662 331.771C337.664 331.8 337.652 331.83 337.634 331.851C337.518 331.953 337.284 332.061 337.14 332.126C336.982 332.198 336.837 332.24 336.699 332.252C336.536 332.266 336.41 332.24 336.33 332.175C336.249 332.11 336.206 332.01 336.195 331.877L336.179 331.686C336.169 331.569 336.191 331.474 336.244 331.4C336.302 331.326 336.398 331.28 336.54 331.263L337.507 331.181ZM340.09 327.021C340.322 327.002 340.45 327.108 340.47 327.342L340.507 327.772C340.527 328.006 340.418 328.133 340.186 328.153L339.678 328.196C339.442 328.216 339.318 328.109 339.298 327.875L339.262 327.445C339.242 327.211 339.345 327.085 339.582 327.065L340.09 327.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.603 233.907C187.46 233.907 180.86 227.03 180.86 218.546C180.86 210.062 187.46 203.184 195.603 203.184C203.745 203.184 210.346 210.062 210.346 218.546C210.346 227.03 203.745 233.907 195.603 233.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.496 190.523C183.496 190.523 180.388 200.027 189.558 204.024L190.731 206.132L184.987 211.961C184.987 211.961 177.906 198.674 178.673 193.956C178.673 193.956 179.769 189.164 183.496 190.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.909 233.907C186.057 233.907 179.692 227.36 179.692 219.284C179.692 211.208 186.057 204.661 193.909 204.661C201.761 204.661 208.126 211.208 208.126 219.284C208.126 227.36 201.761 233.907 193.909 233.907Z",
    fill: "#00D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.602 196.115L180.86 192.282L184.149 191.802C183.447 179.181 186.631 175.42 186.631 175.42L187.371 175.347L190.594 175.026L196.656 168.554V166.717C188.139 167.759 183.431 171.92 180.888 176.796C176.393 185.353 178.602 196.115 178.602 196.115Z",
    fill: "#00D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.344 173.025V175.347L190.566 175.026L196.628 168.554C196.628 168.554 187.251 170.714 187.344 173.025Z",
    fill: "black",
    stroke: "#4C4981",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.602 196.115L180.86 192.282V176.819C176.393 185.353 178.602 196.115 178.602 196.115Z",
    fill: "black",
    stroke: "#FCB827",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.181 225.295C216.398 223.049 216.561 215.475 220.545 208.379C224.528 201.282 230.824 197.35 234.606 199.597C238.389 201.843 238.226 209.417 234.243 216.513C230.259 223.61 223.964 227.542 220.181 225.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26 211.206C221.275 218.303 216.386 223.044 220.168 225.299C223.95 227.554 234.966 226.427 238.951 219.324C242.935 212.221 239.318 202.412 235.536 200.157C231.754 197.902 229.25 204.092 225.26 211.206Z",
    fill: "#00D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M189.783 160.076C189.783 182.755 204.871 204.61 226.921 204.61C237.51 204.61 247.666 200.284 255.154 192.582C262.641 184.88 266.848 174.435 266.848 163.543C266.848 152.651 262.641 142.205 255.154 134.504C247.666 126.802 237.51 122.475 226.921 122.475C204.871 122.498 189.783 137.392 189.783 160.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.921 203.505C204.869 203.505 186.993 185.119 186.993 162.438C186.993 139.757 204.869 121.37 226.921 121.37C248.972 121.37 266.848 139.757 266.848 162.438C266.848 185.119 248.972 203.505 226.921 203.505Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.428 144.241C225.676 146.039 222.864 151.09 218.6 153.903C212.572 157.849 204.723 156.829 197.839 154.878C194.003 153.802 189.991 152.488 186.215 153.683C185.659 153.936 185.046 154.026 184.444 153.943C183.622 153.7 183.217 152.764 182.948 151.93C178.278 137.611 180.378 121.393 187.426 108.145C189.245 104.729 191.427 101.426 194.43 99.0524C196.798 97.1865 199.582 95.9632 202.388 94.9203C207.517 93.0259 212.821 91.6791 218.217 90.9009C219.17 90.7229 220.143 90.6906 221.105 90.8051C222.426 91.025 223.61 91.7578 224.788 92.4117C229.835 95.1944 235.432 96.7579 241.154 96.9836C248.827 97.2823 257.596 95.422 263.51 100.484C270.635 106.556 268.859 118.4 273.479 126.641C276.538 132.092 282.435 136.05 283.405 142.257C283.658 144.154 283.54 146.083 283.06 147.933C280.802 157.483 271.813 164.879 262.233 165.054C260.762 165.169 259.288 164.859 257.98 164.157C257.122 163.556 256.365 162.815 255.738 161.964C249.463 154.32 242.283 139.754 230.428 144.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.948 147.775C183.217 148.61 183.622 149.546 184.444 149.788C185.046 149.871 185.659 149.782 186.215 149.529C189.991 148.334 194.025 149.647 197.834 150.724C204.723 152.674 212.588 153.717 218.595 149.748C222.864 146.93 225.671 141.856 230.428 140.086C242.283 135.576 249.463 150.166 255.755 157.81C256.382 158.66 257.139 159.401 257.996 160.003C259.305 160.704 260.778 161.014 262.249 160.899C271.797 160.724 280.791 153.328 283.076 143.779C283.202 143.215 283.312 142.651 283.394 142.087C283.394 142.138 283.394 142.183 283.422 142.234C283.674 144.131 283.557 146.061 283.076 147.911C280.818 157.46 271.824 164.856 262.249 165.031C260.778 165.147 259.305 164.836 257.996 164.135C257.139 163.533 256.382 162.792 255.755 161.942C249.463 154.298 242.283 139.731 230.428 144.218C225.671 146.017 222.864 151.068 218.595 153.881C212.566 157.827 204.723 156.806 197.834 154.856C193.997 153.779 189.991 152.466 186.215 153.661C185.659 153.914 185.046 154.003 184.444 153.92C183.622 153.678 183.217 152.742 182.948 151.908C181.065 146.049 180.233 139.887 180.493 133.722C180.654 138.503 181.481 143.236 182.948 147.775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.098 320.46C600.174 321.846 600.174 324.897 598.098 326.282L377.213 473.681C374.887 475.233 371.77 473.566 371.77 470.77V402.949C371.77 401.78 372.355 400.687 373.328 400.038L482.609 327.113C485.278 325.332 485.278 321.41 482.61 319.628L373.327 246.65C372.354 246.001 371.77 244.909 371.77 243.74V175.919C371.77 173.123 374.888 171.456 377.213 173.008L598.098 320.46Z",
    stroke: "url(#paint0_linear_10_1247)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.883 320.458C647.959 321.844 647.959 324.895 645.882 326.281L424.997 473.68C422.672 475.232 419.555 473.565 419.555 470.769V402.948C419.555 401.778 420.139 400.686 421.112 400.037L530.393 327.112C533.062 325.331 533.063 321.408 530.394 319.626L421.111 246.649C420.139 245.999 419.555 244.907 419.555 243.738V175.918C419.555 173.122 422.672 171.454 424.998 173.007L645.883 320.458Z",
    stroke: "#7788E3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.361 320.46C538.285 321.846 538.285 324.897 540.361 326.282L761.246 473.681C763.572 475.233 766.689 473.566 766.689 470.77V402.949C766.689 401.78 766.105 400.687 765.132 400.038L655.851 327.113C653.182 325.332 653.181 321.41 655.849 319.628L765.133 246.65C766.105 246.001 766.689 244.909 766.689 243.74V175.919C766.689 173.123 763.572 171.456 761.246 173.008L540.361 320.46Z",
    stroke: "url(#paint1_linear_10_1247)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.576 320.458C490.501 321.844 490.501 324.895 492.577 326.281L713.462 473.68C715.788 475.232 718.905 473.565 718.905 470.769V402.948C718.905 401.778 718.32 400.686 717.347 400.037L608.066 327.112C605.397 325.331 605.396 321.408 608.065 319.626L717.348 246.649C718.321 245.999 718.905 244.907 718.905 243.738V175.918C718.905 173.122 715.787 171.454 713.461 173.007L492.576 320.458Z",
    stroke: "#7788E3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1247",
    x1: 603.361,
    y1: 311.428,
    x2: 371.27,
    y2: 311.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1247",
    x1: 535.099,
    y1: 311.428,
    x2: 767.189,
    y2: 311.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 627,
    height: 348,
    fill: "white",
    transform: "matrix(-1 0 0 1 627 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "translate(371.27 168.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "translate(419.055 168.438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "matrix(-1 0 0 1 767.189 168.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "matrix(-1 0 0 1 719.405 168.438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperativesHighContrast);
export default __webpack_public_path__ + "static/media/operativesHighContrast.668da59f.svg";
export { ForwardRef as ReactComponent };